// eslint-disable-next-line no-unused-vars
async function loadDevModules(vm) {
    // if (import.meta.env.VITE_DEVELOPMENT === 'development') {
    //     await import('@babylonjs/inspector');

    //     if (window.location.search && window.location.search.includes('customizer-three-inspector=true')) {
    //         vm.hasInspector = true;

    //         vm.scene.debugLayer.show({
    //             overlay: true,
    //             showExplorer: true,
    //             showInspector: true,
    //             embedMode: true,
    //         });
    //     }
    // }
}

export default loadDevModules;
